import React, { useMemo, useState } from 'react';
import { Card, Grid, Group, Stack, Text } from '@mantine/core';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import Tabla from '../../../globales/componentes/tabla/tabla';
import type { IDesgloseCostoEquipo, IIndicadoresFamilia, IResultadoCotizacionServicios } from '../../../modelos/CotizadorServicios/entidades/IResultadoCotizacionServicios';
import { columnasDesgloseServicios } from './constantesTablaDesgloseServicios';
import { ModalDesgloseEquipoVista } from './modalDesgloseEquipoVista';
import { formatoMoneda } from '../interfaces';

const TarjetaIndicador: React.FC<{ titulo: string; indicadores?: IIndicadoresFamilia }> = ({ titulo, indicadores }) => (
    <Card withBorder radius="md" p="sm">
        <Text size="xs" c="dimmed" fw={600}>{titulo}</Text>
        <Group justify="space-between" mt={4}>
            <Text size="lg" fw={700}>{formatoMoneda(indicadores?.Utilidad)}</Text>
            <Text size="sm" fw={600} c="green">{(indicadores?.PorcentajeUtilidad ?? 0).toLocaleString('es-CO', { maximumFractionDigits: 2 })} %</Text>
        </Group>
    </Card>
);

/** Uso interno: utilidad por familia y costos de cada equipo (hoja "Calculador"). */
export const DesgloseInternoVista: React.FC<{ resultado: IResultadoCotizacionServicios }> = ({ resultado }) => {
    const [equipoDetalle, setEquipoDetalle] = useState<IDesgloseCostoEquipo | null>(null);
    const columnas = useMemo(() => columnasDesgloseServicios(setEquipoDetalle), []);

    const tabla = useReactTable({
        data: resultado.Desglose,
        columns: columnas,
        getCoreRowModel: getCoreRowModel(),
        getRowId: fila => fila.EquipoId
    });

    return (
        <Stack gap="md">
            <Grid>
                <Grid.Col span={{ base: 12, md: 6 }}>
                    <TarjetaIndicador titulo="Utilidad ascensores" indicadores={resultado.IndicadoresAscensores} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6 }}>
                    <TarjetaIndicador titulo="Utilidad escaleras, rampas y andenes" indicadores={resultado.IndicadoresEscaleras} />
                </Grid.Col>
            </Grid>
            <Tabla tabla={tabla} minWidth={1100} />
            <ModalDesgloseEquipoVista equipo={equipoDetalle} alCerrar={() => setEquipoDetalle(null)} />
        </Stack>
    );
};
